/**
 * Minimal incremental parser for named Server-Sent Events
 * (`event: x\ndata: {...}\n\n` frames), tolerant of chunk boundaries.
 */
export interface SseEvent {
  event: string;
  data: string;
}

export function createSseParser(
  onEvent: (event: SseEvent) => void,
): (chunk: string) => void {
  let buffer = '';

  return (chunk: string) => {
    buffer += chunk;

    // Frames are separated by a blank line. Keep the trailing partial frame.
    let boundary = buffer.indexOf('\n\n');
    while (boundary !== -1) {
      const frame = buffer.slice(0, boundary);
      buffer = buffer.slice(boundary + 2);

      let event = 'message';
      const dataLines: string[] = [];
      for (const line of frame.split('\n')) {
        if (line.startsWith('event:')) {
          event = line.slice(6).trim();
        } else if (line.startsWith('data:')) {
          dataLines.push(line.slice(5).trimStart());
        }
        // comments (":") and other fields are ignored
      }
      if (dataLines.length > 0) {
        onEvent({ event, data: dataLines.join('\n') });
      }

      boundary = buffer.indexOf('\n\n');
    }
  };
}
